const config = {
  apiKey: process.env.REACT_APP_IPIFY_API_KEY,
  apiUrl: process.env.REACT_APP_IPIFY_API_URL || 'https://geo.ipify.org/api/v2/country,city'
};

if (!config.apiKey) {
  console.error('REACT_APP_IPIFY_API_KEY environment variable is required');
}

export const apiKey = config.apiKey;
export const apiUrl = config.apiUrl;
export default config;